/**
 * Ad-click attribution capture.
 *
 * The click ID only exists on the LANDING url. By the time someone searches a
 * fare they have navigated several times and it is long gone, so it has to be
 * grabbed on first paint and kept for the session.
 *
 * sessionStorage, not localStorage: attribution belongs to this visit. A gclid
 * kept for weeks would credit an old ad for a booking it had nothing to do with.
 * Kept for 30 days would be worse than having none, because it would look right.
 */
const KEY = "pulpit_attribution"
const CLICK_IDS = ["gclid", "gbraid", "wbraid", "fbclid", "msclkid"]
const UTMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"]

/** GA4 stores its client id in the _ga cookie as GA1.1.<client_id>. */
const gaClientId = () => {
  const m = document.cookie.match(/_ga=GA\d\.\d\.(\d+\.\d+)/)
  return m ? m[1] : null
}

/**
 * Read the landing URL once and remember it. Safe to call on every render —
 * it only writes the first time, so an in-app navigation can't overwrite the
 * click that actually brought the visitor here.
 */
export function captureAttribution() {
  try {
    if (sessionStorage.getItem(KEY)) return read()

    const q = new URLSearchParams(window.location.search)
    const data = {}
    CLICK_IDS.forEach((k) => { if (q.get(k)) data[k] = q.get(k) })
    UTMS.forEach((k) => { if (q.get(k)) data[k] = q.get(k) })
    data.landing_page = window.location.pathname + window.location.search
    data.referrer = document.referrer || null

    sessionStorage.setItem(KEY, JSON.stringify(data))
    return read()
  } catch {
    return {} // private mode / storage disabled — attribution is never worth an error
  }
}

/** What to send with an API call. GA's client id is read live, not cached. */
export function read() {
  try {
    const data = JSON.parse(sessionStorage.getItem(KEY) || "{}")
    const cid = gaClientId()
    if (cid) data.ga_client_id = cid
    return data
  } catch {
    return {}
  }
}

export default { captureAttribution, read }
